<template>
    <v-footer app fixed dark dense>
        <v-container fluid pa-2>
            <v-layout>
                <v-flex xs12 text-xs-center><img src="@/assets/csueb.fullname.long.KO.svg" class="img-height" alt="California State University, East Bay"></v-flex>
            </v-layout>
        </v-container>
    </v-footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.img-height{
    margin-top:5px;
    height: 12px;
}
</style>
